import { OidcConfiguration } from './auth-config.model';

export const authConfig: OidcConfiguration = {
  authority: 'https://auth.prod.orion.cz.foxconn.com/realms/OrionProd',
  authWellknownEndpoints: {
    authorizationEndpoint:
      'https://auth.prod.orion.cz.foxconn.com/realms/OrionProd/protocol/openid-connect/auth',
    endSessionEndpoint:
      'https://auth.prod.orion.cz.foxconn.com/realms/OrionProd/protocol/openid-connect/logout',
    jwksUri:
      'https://auth.prod.orion.cz.foxconn.com/realms/OrionProd/protocol/openid-connect/certs',
    tokenEndpoint:
      'https://auth.prod.orion.cz.foxconn.com/realms/OrionProd/protocol/openid-connect/token',
    userInfoEndpoint: 'https://auth.prod.orion.cz.foxconn.com/realms/OrionProd/userinfo',
  },
  autoUserInfo: false,
  clientId: 'orionweb-dev-x698wqpF8lLaHEWfCVDkOoczTW',
  clientSecret: 'fsWmHB63ZybMtvIkdYIqUKwP7sewuggV',
  forbiddenRoute: '/forbidden',
  historyCleanupOff: true,
  issValidationOff: true,
  logLevel: 0,
  maxIdTokenIatOffsetAllowedInSeconds: 600,
  postLoginRoute: '/dashboard',
  postLogoutRedirectUri: `${window.location.origin}/home`,
  redirectUrl: `${window.location.origin}/home`,
  renewTimeBeforeTokenExpiresInSeconds: 10,
  responseType: 'code',
  scope: 'openid profile offline_access',
  silentRenew: true,
  silentRenewUrl: '',
  startCheckSession: false,
  triggerAuthorizationResultEvent: true,
  unauthorizedRoute: '/unauthorized',
  useRefreshToken: true,
};
